import React, {Component, Fragment} from 'react';
import './App.css';
import './button.css';
import CalendarGraph from './CalendarGraph';
import {inject} from 'mobx-react';
import GitHubButton from 'github-buttons/dist/react';
import {createArray} from "./stores/graphStore";

@inject('graphStore')
class App extends Component {
    patternify = (trimRight = false) => {
        const {graphStore: {m}} = this.props;
        let pattern = '';
        let stopIdx = m.length;
        if (trimRight) {
            for (stopIdx = 52; stopIdx > 0; stopIdx--) {
                const notEmpty = !!m[stopIdx].find(d => d !== 0);
                if (notEmpty) {
                    stopIdx++;
                    break;
                }
            }
        }
        for (let j = 0; j < 7; j++) {
            let str = '';
            for (let i = 0; i < stopIdx; i++) {
                str += m[i][j];
            }
            pattern += `\t"${str}"${j !== 6 ? ',' : ''}\n`;
        }
        return `[\n${pattern}]`.replace(/0/g, ' ');
    };

    handleFile = (e) => {
        const {graphStore: {m}} = this.props;
        const content = e.target.result;
        console.log('file content', content);
        const arr = JSON.parse(content);
        console.log(arr);
        const newM = createArray();
        for (let j = 0; j < 7; j++) {
            for (let i = 0; i < 52; i++) {
                const c = arr[j].charAt(i);
                if (c && c !== ' ') {
                    newM[i][j] = c;
                }
            }
        }
        m.replace(newM);
        this.inputElement.value = '';
    };

    handleChangeFile = (file) => {
        const fileData = new FileReader();
        fileData.onloadend = this.handleFile;
        fileData.readAsText(file);
    };

    downloadFile = () => {
        const pattern = this.patternify();
        // return console.log(pattern);
        const file = new Blob([pattern], {type: 'text/plain'});
        const element = document.createElement('a');
        element.href = URL.createObjectURL(file);
        element.download = 'pattern-' + Math.random().toString(36).substring(2, 8) + '.json';
        element.click();
    };

    render() {
        const {graphStore} = this.props;

        return <Fragment>
            <div className='pagehead'>
                <div>
                    <div className='ico-wrapper'>
                        <svg className="octicon" viewBox="0 0 12 16" version="1.1" width="12" height="16" aria-hidden="true">
                            <path fillRule="evenodd" d="M4 9H3V8h1v1zm0-3H3v1h1V6zm0-2H3v1h1V4zm0-2H3v1h1V2zm8-1v12c0 .55-.45 1-1 1H6v2l-1.5-1.5L3 16v-2H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1zm-1 10H1v2h2v-1h3v1h5v-2zm0-10H2v9h9V1z"/>
                        </svg>
                        <h1 className='title'>GitHub Spray Generator</h1>
                    </div>
                    <GitHubButton
                        href='https://github.com/Annihil/github-spray'
                        data-size='large'
                        data-show-count
                    >GitHub Spray</GitHubButton>
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexFlow: 'column',
                    alignItems: 'center'
                }}
            >
                <div className='description'>
                    <p className='text-gray-dark'>Click to add contribution, right click to remove.</p>
                </div>
                <div
                    style={{
                        display: 'inline-flex',
                        flexFlow: 'column',
                        alignItems: 'flex-end'
                    }}
                >
                    <CalendarGraph/>
                    <div>
                        <button
                            style={{marginTop: '.5rem', marginRight: '.5rem'}}
                            className='btn'
                            onClick={() => graphStore.reset()}
                        >Reset
                        </button>
                        <button
                            style={{marginTop: '.5rem', marginRight: '.5rem'}}
                            className='btn'
                            onClick={() => this.inputElement.click()}
                        >Load
                        </button>
                        <input
                            type='file'
                            onChange={e => this.handleChangeFile(e.target.files[0])}
                            style={{display: 'none'}}
                            ref={ref => this.inputElement = ref}
                            accept='.json'
                        />
                        <button
                            style={{marginTop: '.5rem'}}
                            className='btn btn-primary'
                            onClick={this.downloadFile}
                        >Download pattern
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>;
    }
}

export default App;
